import React from "react";
import { Alert } from "@material-ui/lab";
import UserServicesSwitch from "../../../elements/services/UserServicesSwitch";
import SuperAdminConnection from "./SuperAdminConnection";
import PageSpinner from "../../../elements/spinner/PageSpinner";
import { useTranslation } from "react-i18next";

import { StyledServiceGrid, StyledServiceLinkWrapper } from "../../../services/styledServices";

const ServiceList = ({ userId, fetchServicesList, userServices, notification, setNotification }) => {
  const { t } = useTranslation("servicePage");

  if (!userServices) {
    return <PageSpinner position="center" pt="20" pb="20" />;
  }

  if (userServices.length === 0) {
    return <Alert severity="warning">{t("list.emptyData")}</Alert>;
  }

  return (
    <>
      <StyledServiceGrid>
        {userServices && userServices.map((value, key) => (
          <StyledServiceLinkWrapper key={key}>
            <div className="connection__action">
              <UserServicesSwitch
                userId={userId}
                userService={value}
                notification={notification}
                setNotification={setNotification}
                refetch={fetchServicesList}
              />
            </div>
            <SuperAdminConnection
              userId={userId}
              userService={value}
            />
          </StyledServiceLinkWrapper>
        ))}
      </StyledServiceGrid>
    </>
  );
};
export default ServiceList;